
import {
  formatDate,
  formatPriceRP,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { BeneficiaryAccountController } from "@/app/ui/controllers/BeneficiaryAccountController";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { EditRenewRatesClientManagementApiRequestV2 } from "@/data/payload/api/ClientManagementApiRequest";
import { OptionsClass } from "@/domain/entities/MainApp";
import { Options, Vue } from "vue-class-component";
import ConfirmationApprovalRejectClient from "../../global-components/confirmation-approval-reject-client.vue";
import ClientDetailCardBranch from "../../global-components/detail/branch/card-detail-client.vue";
import ClientDetailCardParent from "../../global-components/detail/parent/client-detail.card.vue";
import RenewalRateCard from "../../global-components/detail/parent/renewal-rate-card.vue";
import PriceTypeForm from "../../global-components/price-type-form.vue";
import InfoDetailClient from "../../registration/component/info-detail-client/index.vue";
import InfoPriceClient from "../../registration/component/info-price-client/index.vue";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import ClientRateHistory from "../../global-components/client-rate-history.vue";

@Options({
  components: {
    InfoDetailClient,
    InfoPriceClient,
    RenewalRateCard,
    PriceTypeForm,
    ConfirmationApprovalRejectClient,
    ClientDetailCardBranch,
    ClientDetailCardParent,
    ClientRateHistory
  }
})
class ClientManagementDetail extends Vue {
  renewRateDialog = false;
  isRenewRateConfirmation = false;

  form = {
    isCustomRate: "retail",
    isInsurance: false,
    insurance: "",
    customRates: "",
    priceRateStartDate: "",
    priceRateEndDate: "",
    originCities: [] as OptionsClass[],
    discount: "",
    versionName: "",
    archiveFile: "" as any,
    retailBasedDistrict: false,
    versionBasic: "" as any,
    rateVersionId: ""
  };

  error = {
    isCustomRate: false,
    isInsurance: false,
    insurance: false,
    customRates: false,
    priceRateStartDate: false,
    priceRateEndDate: false,
    originCities: false,
    discount: false,
    versionName: false,
    archiveFile: false,
    retailBasedDistrict: false,
    versionBasic: false
  };

  get customPriceOption() {
    return [
      {
        disabled: false,
        label: this.$t("clientManagement.infoPriceClient.priceRetail").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceRetailDescription").toString(),
        value: "retail"
      },
      {
        disabled: false,
        label: this.$t("clientManagement.infoPriceClient.priceNormal").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceNormalDescription").toString(),
        value: "normal"
      },
      {
        disabled: false,
        label: this.$t("clientManagement.infoPriceClient.priceSpecial").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceSpecialDescription").toString(),
        value: "khusus"
      },
      {
        disabled: false,
        label: this.$t("clientManagement.infoPriceClient.priceCombination").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceCombinationDescription").toString(),
        value: "kombinasi"
      }
    ];
  }

  mounted() {
    this.fetchDetail();
  }

  get id() {
    return this.$route.params.id;
  }

  get title() {
    return this.detailData.clientName;
  }

  get isParent() {
    return this.detailData.clientParentId === 0;
  }

  get detailData() {
    return ClientManagementController.detailClientManagement;
  }

  get isMY() {
    return this.detailData.clientDistrict?.countryCode === "MY";
  }

  get balance() {
    return formatPriceRP(
      this.detailData.clientBalance,
      this.isMY ? "MYR" : "IDR"
    );
  }

  get createdAt() {
    return formatDate(this.detailData.clientCreatedAt);
  }

  get updatedAt() {
    return formatDate(this.detailData.clientUpdatedAt);
  }

  get isRequested() {
    return this.activeRenewalStatus.toLowerCase() === "requested";
  }

  get activeRenewalStatus() {
    if (this.detailData.clientRatePeriodChange.rateVersionId > 0) {
      return this.detailData.clientRatePeriodChange.status || "";
    }

    return this.detailData.clientRenewalRate.clientStatusCustomRate || "";
  }

  get isPeriodApproval() {
    return (
      this.detailData?.clientRatePeriodChange?.status?.toLowerCase() ===
      "requested"
    );
  }

  get clientStatus() {
    return (
      this.detailData?.clientCurrentRate?.clientStatusCustomRate.toLowerCase() ||
      ""
    );
  }

  get errorMessage() {
    return this.detailData.clientRenewalRate.clientStatusUpdatedReason;
  }

  async fetchDetail() {
    await ClientManagementController.getDetailV2(Number(this.id));

    if (this.detailData.clientParentId === 0) {
      BeneficiaryAccountController.getBeneficiaryAccList({
        page: 1,
        limit: 1,
        bankAccType: "beneficiary",
        actortype: "client",
        actorId: this.detailData.id
      });
    }
  }

  goBack() {
    this.$router.push("/client/client-management");
  }

  get isLoading() {
    return ClientManagementController.isLoading;
  }

  get isError() {
    return ClientManagementController.isError;
  }

  get errorCause() {
    return ClientManagementController.isErrorCause;
  }

  get isBasicRateBool() {
    return this.form.isCustomRate === "normal";
  }
  get isMixRateBool() {
    return this.form.isCustomRate === "kombinasi";
  }
  get isCustomRateBool() {
    return this.form.isCustomRate === "khusus";
  }

  onRenewRate() {
    this.renewRateDialog = true;
  }

  renewRate() {
    this.isRenewRateConfirmation = true;
  }

  confirmRenewRateConfirmation() {
    this.isRenewRateConfirmation = false;
    this.renewRateDialog = true;
  }

  closeRenewRateConfirmation() {
    this.isRenewRateConfirmation = false;
  }

  get isValidRenewRate() {
    let result = false;
    if (this.form.isCustomRate === "retail") {
      if (
        !this.form.isInsurance ||
        (this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }
    if (this.form.isCustomRate === "normal") {
      if (
        (this.form.versionBasic &&
          this.form.originCities.length &&
          this.form.discount &&
          !this.error.discount &&
          !this.form.isInsurance) ||
        (this.form.versionBasic &&
          this.form.originCities.length &&
          this.form.discount &&
          !this.error.discount &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }
    if (this.form.isCustomRate === "khusus") {
      if (
        (this.form.versionName &&
          this.form.archiveFile.name &&
          !this.form.isInsurance) ||
        (this.form.versionName &&
          this.form.archiveFile.name &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }
    if (this.form.isCustomRate === "kombinasi") {
      if (
        (this.form.versionName &&
          this.form.versionBasic &&
          this.form.originCities.length &&
          this.form.discount &&
          !this.error.discount &&
          this.form.archiveFile.name &&
          !this.form.isInsurance) ||
        (this.form.versionName &&
          this.form.versionBasic &&
          this.form.originCities.length &&
          this.form.discount &&
          !this.error.discount &&
          this.form.archiveFile.name &&
          this.form.isInsurance &&
          this.form.insurance &&
          !this.error.customRates)
      )
        result = true;
    }
    return (
      result && !this.error.priceRateStartDate && !this.error.priceRateEndDate
    );
  }

  async submitRenewRate() {
    this.isRenewRateConfirmation = false;
    const payload = new EditRenewRatesClientManagementApiRequestV2({
      clientId: Number(this.id),
      versionBasic: this.form.versionBasic.rateVersionName
        ? this.form.versionBasic.rateVersionName
        : this.form.versionBasic,
      isCustomRate: this.isMixRateBool,
      discount: this.form.discount
        ? parseFloat(this.form.discount.replace(",", "."))
        : 0,
      startDate: this.$moment(this.form.priceRateStartDate).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      endDate: this.$moment(this.form.priceRateEndDate).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      versionName: this.form.versionName,
      archiveFile:
        typeof this.form.archiveFile === "object" ? this.form.archiveFile : "",
      rateVersionId: this.detailData.clientCurrentRate.clientCustomRateId,
      isCustomRateOnly: this.isCustomRateBool
    });

    MainAppController.showLoading();
    await ClientManagementController.editRenewRateV2(payload)
      .then(() => {
        this.renewRateDialog = false;
        MainAppController.setSnackbarMessage(
          this.$t("clientManagement.infoPriceClient.parentClientPriceChangeSuccess", { clientName: this.detailData.clientName }).toString()
        );
        MainAppController.setSnackbarTimeout(2000);
        MainAppController.setSnackbar(true);
        ClientManagementController.getDetailV2(this.detailData.id);
        this.onResetForm();
      })
      .catch(err => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            err,
            this.$t("clientManagement.infoPriceClient.parentClientPriceChangeFailed", { clientName: this.detailData.clientName }).toString()
          )
        );
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  onResetForm(): void {
    this.form = {
      archiveFile: "",
      customRates: "",
      discount: "",
      insurance: "",
      isCustomRate: "retail",
      isInsurance: false,
      originCities: [],
      priceRateEndDate: "",
      priceRateStartDate: "",
      retailBasedDistrict: false,
      versionBasic: "",
      versionName: "",
      rateVersionId: ""
    };
  }

  get showClientRateHistory() {
    const permission = FlagsPermissionClient.permission_client_rate_history_view.isEnabled();

    return permission && this.isParent;
  }

  get isApprovalEnable() {
    return FlagsPermissionClient.permission_period_date_time.isEnabled()
  }
}

export default ClientManagementDetail;
